import React, { useEffect, useState } from "react";
import { LuClock } from "react-icons/lu";
import { CiStar } from "react-icons/ci";
import axios from "axios";
import { toast } from "sonner";
const BrowseService = () => {
  const [serviceData, setServiceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchSericeData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://api.upswap.app/api/appointments/get-all-services/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setIsLoading(false);
        setServiceData(response?.data);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.response?.data?.detail || "Failed to update phone");
    }
  };

  useEffect(() => {
    fetchSericeData();
  }, []);

  return (
    <div className="m-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {isLoading
          ? Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow animate-pulse"
              >
                <div className="h-48 bg-gray-200 w-full" />
                <div className="p-4">
                  <div className="h-5 bg-gray-300 rounded w-3/4 mb-2" />
                  <div className="h-4 bg-gray-300 rounded w-1/2 mb-1" />
                  <div className="h-4 bg-gray-300 rounded w-full mb-4" />
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                      <div className="w-4 h-4 bg-gray-300 rounded-full" />
                      <div className="h-4 bg-gray-300 rounded w-10" />
                    </div>
                    <div className="flex items-center space-x-2">
                      <div className="w-4 h-4 bg-gray-300 rounded-full" />
                      <div className="h-4 bg-gray-300 rounded w-10" />
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="h-5 bg-gray-300 rounded w-16" />
                    <div className="h-8 bg-gray-300 rounded w-24" />
                  </div>
                </div>
              </div>
            ))
          : serviceData?.map((service) => (
              <div
                key={service.id}
                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="h-fit overflow-hidden">
                  <img
                    src={service.image?.[0]}
                    alt={service.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">
                    {service.name}
                  </h3>
                  <p className="text-xs text-gray-600 mb-1 font-medium">
                    {service.service_category}
                  </p>
                  <p className="text-sm text-gray-600 mb-4">
                    {service.description}
                  </p>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center text-sm text-gray-500">
                      <LuClock size={16} className="mr-1" />
                      <span>{service.duration}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <CiStar size={16} className="text-yellow-400 mr-1" />
                      <span>{service.rating}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-lg font-semibold text-gray-900">
                      ${service.price}
                    </div>
                    <button
                      onClick={() => console.log(service)}
                      className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default BrowseService;
